import React from 'react';

import {changeStatus} from './records-list';
import {DocumentList} from 'components/documents';

export const RecordDetailList = ({ record }) => (
  <DocumentList>
    <li>Номер заявки: <strong>{record.get('id')}</strong></li>
    <li>Стан заявки: <strong>{changeStatus(record.get('status'))}</strong></li>
    <li>Початок прийому: <strong>{record.get('reception_data').get('start_date')}, {new Date('2018-01-01T' + record.get('reception_data').get('start_time')).toLocaleTimeString('uk-UA', {hour: '2-digit', minute:'2-digit'})}</strong></li>
    <li>Кінець прийому: <strong>{record.get('reception_data').get('end_date')}, {new Date('2018-01-01T' + record.get('reception_data').get('end_time')).toLocaleTimeString('uk-UA', {hour: '2-digit', minute:'2-digit'})}</strong></li>
    <li>Лікарня: <strong>{record.get('reception_data').get('staff_data').get('institution_data').get('full_title')}</strong></li>
    <li>Лікар: <strong>{record.get('reception_data').get('staff_data').get('user_data').get('last_name')} {record.get('reception_data').get('staff_data').get('user_data').get('first_name')} {record.get('reception_data').get('staff_data').get('user_data').get('middle_name')}</strong></li>
    <li>Посада лікаря: <strong>{record.get('reception_data').get('staff_data').get('position_title')}</strong></li>
    <li>Кабінет лікаря: <strong>{record.get('reception_data').get('staff_data').get('cabinet_number')}</strong></li>
    <li>Телефон лікаря: <strong>{record.get('reception_data').get('staff_data').get('user_data').get('phone') ? record.get('reception_data').get('staff_data').get('user_data').get('phone') : "Не вказано"}</strong></li>
    <li>Адреса лікарні: <strong>{record.get('reception_data').get('staff_data').get('institution_data').get('address')}</strong></li>
  </DocumentList>
);



// WEBPACK FOOTER //
// ./src/registry/records/record-detail-list.js